(function () {
    window.DamonUtils = require('./DamonUtils.js');
})();
